import { ISelectOption } from './utils';

export interface IClinician {
  id: string;
  name: string;
  email: string;
  password: string;
  metadata: any; // json object
  createdAt: string;
  updatedAt: string;
  clinicId: number;
  locked: boolean;
  lockedUntil: string;
}

export type ClinicianView = Pick<IClinician, 'id' | 'name' | 'email' | 'clinicId'>;

export type SelectOptionClinician = ISelectOption<ClinicianView>;
